export default "__VITE_ASSET__GeloHagW__"